<div class="row">
    <div class="col-md-12">
        <form [formGroup]="form.get('personalDetails')" *ngIf="form.get('personalDetails')">
            <div class="row">
                <div class="col-sm-12 col-md-6 col-xl-4 mt-3 mb-3">
                    <mat-label class="font-style"> {{ 'PROFILE_PAGE.PERSONAL_TAB.LABELS.FIRST_NAME' | transloco }}
                    </mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                        <input type="text" matInput
                            placeholder="{{ 'PROFILE_PAGE.PERSONAL_TAB.INPUT_PLACEHOLDER.FIRST_NAME' | transloco }}"
                            formControlName="first_name" [readonly]="isfedrated == true" (keypress)="onKeyPress($event)"
                            (paste)="onKeyPress($event)" />
                    </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-6 col-xl-4 mt-3 mb-3">
                    <mat-label class="font-style">{{ 'PROFILE_PAGE.PERSONAL_TAB.LABELS.LAST_NAME' | transloco }}
                    </mat-label>
                    <mat-form-field class="example-full-width custom-text-field">
                        <input type="text" matInput formControlName="last_name" [readonly]="isfedrated == true"
                            (keypress)="onKeyPress($event)" (paste)="onKeyPress($event)" />
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6 col-xl-4 mt-3 mb-3">
                    <mat-label class="font-style">{{ 'PROFILE_PAGE.PERSONAL_TAB.LABELS.ORGANIZATION_NAME' | transloco }}
                    </mat-label>
                    <mat-form-field class="example-full-width custom-text-field">
                        <input type="text" matInput name="organization_name" formControlName="organization_name"
                            readonly />
                    </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-6 col-xl-4 mt-3 mb-3">
                    <mat-label class="font-style">{{ 'PROFILE_PAGE.PERSONAL_TAB.LABELS.PHONE_NUMBER' | transloco }}
                    </mat-label>
                    <mat-form-field class="example-full-width custom-text-field">
                        <input type="text" matInput formControlName="telephone" name="telephone"
                            [readonly]="!isEditable" pattern="[0-9+\-()]*" (keypress)="numberOnly($event)"
                            (paste)="validatePaste($event)" />
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6 col-xl-4 mt-3 mb-3">
                    <mat-label class="font-style">{{ 'PROFILE_PAGE.PERSONAL_TAB.LABELS.EMAIL_ADDRESS' | transloco }}
                    </mat-label>
                    <mat-form-field class="example-full-width custom-text-field">
                        <input type="email" matInput formControlName="email" name="email" readonly />
                    </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-6 col-xl-4 mt-3 mb-3">
                    <mat-label class="font-style">{{ 'PROFILE_PAGE.PERSONAL_TAB.LABELS.ROLE' | transloco }} </mat-label>
                    <mat-form-field class="example-full-width custom-text-field">
                        <input type="text" matInput fname="security_role" formControlName="security_role" readonly />
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6 col-xl-4 mt-3 mb-3" *ngIf="UserData?.license?.endDate">
                    <mat-label class="font-style">{{ 'PROFILE_PAGE.PERSONAL_TAB.LABELS.LICENSE_EXPIRES_ON' | transloco
                        }}</mat-label>

                    <dx-date-box class="dx-date-custom-wrapper" formControlName="licence_end_date"
                        displayFormat="dd-MMM-yyyy" [inputAttr]="{ 'aria-label': 'Choose Date' }" [disabled]="true"
                        blockDateTyping>
                    </dx-date-box>
                    <!-- Added 'blockDateTyping' directive to block typing  in dx-datepicker -->
                </div>

                <div class="col-sm-12 col-md-6 col-xl-4 mt-3 mb-3">
                    <mat-label class="font-style" style="display: inline-block">{{
                        'PROFILE_PAGE.PERSONAL_TAB.LABELS.DEFUALT_LANGUAGE' | transloco }}
                    </mat-label>
                    <mat-select panelClass="dropdown-wrapper" class="lubricant-select dropdown-wrapper"
                        formControlName="default_language" name="default_language" [disabled]="isEditable === false">
                        <mat-option class="option-list" *ngFor="let l of filterLanguage" [value]="l.settingValueId">{{
                            l.value }} </mat-option>
                    </mat-select>
                </div>
            </div>
        </form>
    </div>
</div>